function ErrorView() {
  return (
    <div>
      ERROR
    </div>
  )
}

export default ErrorView
